import lazyLoadingDirective from "@km/js/lazyLoadingDirective";

export default defineNuxtPlugin((nuxtApp)=>{
    nuxtApp.vueApp.directive("lazyload", lazyLoadingDirective)
})
